// extracted by mini-css-extract-plugin
module.exports = {"active":"header-module--active--326IL","desktopNav":"header-module--desktopNav--1RCDe"};